import pulse from '@finn-no/pulse-sdk';
import { IconCheck16 } from '@warp-ds/icons/react/check-16';
import { Box, Button } from '@warp-ds/react';
import type React from 'react';
import { FinnLogo } from './FinnLogo.js';

export const FinnBox: React.FC = () => {
  const targetUrl = '/mobility/create?model=car-used';

  const trackClick = () => {
    pulse.trackEvent({
      name: 'Car lookup',
      type: 'Click',
      intent: 'Open',
      object: {
        type: 'UIElement',
        elementType: 'Button',
        id: 'nyBilAnnonseBtn',
      },
      target: {
        type: 'Page',
        pageType: 'product_description',
        id: `${targetUrl}`,
      },
      vertical: {
        name: 'mobility',
      },
    });
  };

  return (
    <Box bordered className="flex flex-col justify-between h-full">
      <div className="md:mb-16 flex-grow">
        <div className="mb-24">
          <FinnLogo />
        </div>
        <h2 className="h3 mb-8 flex items-center">Selg bilen selv på FINN</h2>
        <p className="h4 mb-16">Du håndterer salget selv, og får høyest pris for bilen.</p>
        <p className="mb-24">
          FINN tilbyr også Smidig bilhandel som en tilleggstjeneste, der du veiledes hele veien gjennom salget på en
          enkel, trygg og sikker måte.
        </p>
        <div className="flex-col">
          <div className="flex cols-2 items-center mb-8">
            <IconCheck16 className="s-icon-positive mr-8" />
            Få høyest pris for bilen
          </div>
          <div className="flex cols-2 items-center mb-8">
            <IconCheck16 className="s-icon-positive mr-8" />
            Mulighet for Smidig bilhandel
          </div>
          <div className="flex cols-2 items-center mb-8">
            <IconCheck16 className="s-icon-positive mr-8" />
            Selg til både private og forhandlere
          </div>
        </div>
      </div>
      <div className="mt-auto mb-16">
        <Button href={targetUrl} fullWidth onClick={trackClick}>
          Lag annonsen
        </Button>
      </div>
      <p className="text-12 mt-4">
        Pris fra 359 kr for 14 dagers annonsering, avhenger av kjøretøyets salgspris, annonsens varighet og eksponering.
        Bruk av Smidig bilhandel medfører ekstra kostnader i tillegg til annonsepris.
      </p>
    </Box>
  );
};
